import React from 'react';
import SectionClosingStockReport from '../SectionClosingStockReport';
import * as fobSectionApi from '@/services/fobSectionApi';

const FOBClosingStockReport = () => {
  return (
    <SectionClosingStockReport
      sectionName="FOB Section"
      backRoute="/sections/fob"
      fetchClosingStock={fobSectionApi.getFobClosingStock}
      fetchOperations={fobSectionApi.getFobOperations}
      exportPrefix="fob"
      summaryGroupBy="operation"
      showBundleCount={true}
    />
  );
};

export default FOBClosingStockReport;
